/**
 *
 * ServiceTypeEnumFilter
 *
 */
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';
import { ServiceTypeEnumPicker } from 'app/components/pickers/StaticOptionsPickers/ServiceTypeEnumPicker';

export const ServiceTypeEnumFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <ServiceTypeEnumPicker
      onChange={handleOnChange}
      value={props.value as Entity<number> | undefined}
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      additionalItem={props.additionalItem as Entity<number> | undefined}
      ariaLabel={props.label}
      size="small"
      id={props.id}
    />
  );
};
export default ServiceTypeEnumFilter;
